.container {
    position: relative;
}

.inputWrapper {
    position: relative;
    background: var(--static-background-standard);
    color: var(--static-text-standard);
}

.input {
    width: 100%;
    padding: 6px 12px;
    text-align: left;
    background-color: white;
    border: 1px solid var(--static-divider-standard);
    border-radius: 8px;
    font-size: var(--fs-small);
    line-height: 20px;
    text-overflow: ellipsis;
    background: var(--static-background-standard);
    color: var(--static-text-standard);
    /*box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);*/
}

.input:focus {
    outline: none;
    border-color: var(--primary-enabled);
}

.toggleButton {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    padding: 4px;
    background: none;
    border: none;
    cursor: pointer;
}

.dropdownList > ul {
    margin-top: -1px;
    background-color: var(--static-background-standard);
    border: 1px solid var(--static-divider-standard);
    border-radius: 12px;
    box-shadow: var(--box-shadow);
    overflow: auto;
    padding: 0;
}

.option {
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.option:hover {
    background-color: var(--selectable-hover);
}

.selectedOption {
    background-color: var(--selectable-selected);
}

/*.icon {*/
/*    width: 20px;*/
/*    height: 20px;*/
/*    color: #9ca3af;*/
/*}*/

